import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { INSURANCE_TYPE } from "./apiRoutes";

interface UseGetProps {
  communityId: string
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getActiveInsuranceTypes = async (communityId: string) =>
  await axiosAuth.get(`${INSURANCE_TYPE(communityId)}/active`);

const useGetActiveInsuranceTypes = ({
  communityId,
  queryParams
}: UseGetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["insurance-active-types", communityId],
    queryFn: () => getActiveInsuranceTypes(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetActiveInsuranceTypes;
